import React from 'react';
import Logo from '../../synaccess_white.svg';
import TextInput from '../common/inputs/textInput';
import Loading from '../common/loading';
import parseQuery from '../../utils/parseQueryParams';

export default class ConfirmEmail extends React.Component {
  state = {
    loading: false,
    password: "",
    errorMsg: "",
  }
  componentDidMount() {
    if (this.props.user) {
      this.setState({ loading: true })
      this.props.confirmEmail({
        cookie: localStorage.getItem("token"),
        token: parseQuery(this.props.history.location.search).t
      },(err) => {
        this.setState({
          loading: false,
          errorMsg: err ? this.getErrorMessage(err) : "",
        });
      });
    }
  }
  getErrorMessage = err => {
    const responseData = err && err.response && err.response.data;
    if (responseData && responseData.message) {
      return responseData.message;
    }
    if (err && err.message) {
      return err.message;
    }
    return "Unable to verify email. Please check the link and password, then try again.";
  }
  submitPass = () => {
    if (!this.state.password) {
      this.setState({ errorMsg: "Password is required." });
      return;
    }
    this.setState({
      loading: true,
      errorMsg: "",
    });
    this.props.confirmEmail({
      password: this.state.password,
      token: parseQuery(this.props.history.location.search).t
    }, (err) => {
      this.setState({
        loading: false,
        errorMsg: err ? this.getErrorMessage(err) : "",
      });
    })
  }
  render() {
    const {
      user ,
      loading,
    } = this.props;
    if (loading) {
      return <Loading fixed black />
    }

    return (
      <div className="welcome-background">
        <div className="grid-container">

        <div className="grid-x grid-padding-x grid-padding-y">
            {user && <div className="cell" style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  border: "solid white 1px",
                  padding: '10px 30px',
                  borderRadius: '3px',
                  color: "white",
                  cursor: 'pointer',
                  // borderBottom: "solid white 1px"

                }}
                onClick={() => {
                  this.props.signout()
                }}
              >
                <i className="material-icons">logout</i>
                <span>
                  <b>
                    Sign Out
                  </b>
                </span>
              </div>
            </div>}
          </div>
          <div className="grid-x grid-padding-x grid-padding-y align-center"  style={{ marginTop: "0vh" }}>
            <div
                className="cell large-4 medium-6 small-10"
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >             
               <div
                style={{
                  padding: "0px",
                  marginTop: "10vh",
                  borderRadius: "2px",
                  width: "100%"
                }}
              >
                <div
                  style={{
                    paddingBottom: "20px",
                  }}
                >
                  <img alt="logo" src={Logo} width="165px" />
                </div>
                <div
                  style={{
                    boxShadow: "3px 3px 20px rgba(0,0,0,0.05)",
                    width: "100%",
                    backgroundColor: "white",
                    padding: "50px 20px",
                    display: 'flex',
                    // alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: "column",
                    // textAlign: 'center',
                    borderRadius: "3px"
                  }}
                >
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <i className="material-icons" style={{ fontSize: "100px", width: "100px"}}>approval</i>
                  </div>
                  <div
                    style={{
                      paddingBottom: "20px",
                      paddingTop: "20px",
                      borderRadius: "2px",
                      fontSize: "125%",
                      fontWeight: "600",
                    }}
                  >
                    Verify your email
                  </div>
                  <div style={{
                    // textAlign: 'start'
                  }}>
                    Please enter the password for the Synaccess Cloud Account associated with your email. 
                  </div>
                  <TextInput
                    value={this.state.password}
                    type="password"
                    callback={text => this.setState({ password: text })}
                    label="Password"
                  />
                  {this.state.errorMsg && (
                    <div
                      style={{
                        color: "maroon",
                        padding: "0px 0px 20px 0px",
                      }}
                    >
                      {this.state.errorMsg}
                    </div>
                  )}
                  <div
                    className="button"
                    style={{
                      opacity: this.state.loading ? 0.7 : 1,
                      pointerEvents: this.state.loading ? "none" : undefined,
                    }}
                    onClick={() => {
                      this.submitPass();
                    }}
                  >
                    {this.state.loading ? "Verifying..." : "Continue"}
                  </div>
                </div>
                {/* <div
                  style={{
                    padding: "20px 10px 10px 10px",
                    color: "white",
                  }}
                >
                  Need Help? {" "}
                  <Link to="/contact">
                    <b style={{ color: "white" }}>Contact Us</b> 
                  </Link>
                </div> */}
              </div>

            </div>
          </div>
        </div>
      </div>
    )
  }
}
